import { Link } from "react-router-dom";
import { ArrowUpRight, CreditCard, Mail, MonitorPlay, Nfc, QrCode, Smartphone, UserCheck } from "lucide-react";
import { NFC_DESIGNER_URL, ROUTES } from "@/constants/routes";

const TILES = [
  { key: "card", label: "Digital Card", to: ROUTES.card, icon: CreditCard },
  { key: "profile", label: "Public Profile", to: ROUTES.profile, icon: UserCheck },
  { key: "qr", label: "QR Identity", to: ROUTES.card, icon: QrCode },
  { key: "signature", label: "Email Signature", to: ROUTES.signature, icon: Mail },
  { key: "background", label: "Meeting Background", to: ROUTES.background, icon: MonitorPlay },
  { key: "home-screen", label: "Home Screen", to: ROUTES.homeScreen, icon: Smartphone },
  { key: "nfc", label: "NFC Card Designer", href: NFC_DESIGNER_URL, icon: Nfc },
];

const tileClass = "group flex items-center justify-between gap-3 rounded-lg border border-border bg-card px-4 py-4 text-sm transition-colors duration-200 hover:border-foreground/40";

export function NfcBanner() {
  return (
    <a href={NFC_DESIGNER_URL} target="_blank" rel="noopener noreferrer" data-testid="nfc-designer-banner" className="group flex flex-col gap-3 rounded-lg bg-ink px-6 py-6 text-[#F4F2EC] sm:flex-row sm:items-center sm:justify-between">
      <span className="flex items-center gap-4">
        <Nfc className="h-6 w-6 shrink-0 text-gold" />
        <span><span className="block font-serif text-2xl tracking-tight">Design Your NFC Card</span><span className="block text-sm text-zinc-400">Create a physical card that opens your MetWorth with a tap.</span></span>
      </span>
      <ArrowUpRight className="h-5 w-5 shrink-0 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </a>
  );
}

export function QuickLinks() {
  return (
    <nav data-testid="quick-links" aria-label="Quick links" className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {TILES.map(({ key, label, to, href, icon: Icon }) => {
        const inner = <><span className="flex items-center gap-3"><Icon className="h-4 w-4 text-gold" />{label}</span><ArrowUpRight className="h-4 w-4 text-muted-foreground" /></>;
        return href ? (
          <a key={key} href={href} target="_blank" rel="noopener noreferrer" data-testid={`quick-link-${key}`} className={tileClass}>{inner}</a>
        ) : (
          <Link key={key} to={to} data-testid={`quick-link-${key}`} className={tileClass}>{inner}</Link>
        );
      })}
    </nav>
  );
}
